const MEMORY_CARD_OPTIONS_PANEL_ID_PREFIX = 'ai-chat-memory-card-options';

/** Per card, never shared: `Dropdown` matches its mobile sheet by this id, and cards sharing one all claim the same sheet. */
export const memoryCardOptionsPanelId = (memoryId: string): string => `${MEMORY_CARD_OPTIONS_PANEL_ID_PREFIX}-${memoryId}`;

export interface AiChatMemoryCardProps {
  memoryId: string;
  /** A fact's last-updated date, or a visual entity's name. */
  heading: string;
  /** A fact's text, or a visual entity's description. */
  body: string;
  /** Visual entities only. */
  imageUrl?: string;
  deleteConfirmationText: string;
  onDelete: () => void;
}
